import AutoProduct from './src/main'

AutoProduct.install = function (Vue) {
    Vue.component(AutoProduct.name, AutoProduct)
}

export default AutoProduct